import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ClaimService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, ClaimPaginationOptions, ClaimsFilters } from "src/types";

const useClaims = (
  claimService: ClaimService,
  dateTimeRange?: DateTimeRange,
  filter?: ClaimsFilters,
  paginationOptions?: ClaimPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getClaimsQueryParams(dateTimeRange, filter, paginationOptions);

  const {
    data: paginatedClaims,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedClaims(queryParams),
    queryFn: () => claimService.getClaims(queryParams)
  });

  const refreshClaims = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedClaims(),
      exact: false
    });
  };

  return { paginatedClaims, fetchError, isLoading, refreshClaims };
};

export { useClaims };
